
  <!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<well-wizard [(activeIndex)]="index" [isEdit]="isEditMode" >

    <well-wizard-tab [label]="'company.subscription-type.add-title' | translate ">
      <well-subscription-type-tab #subscriptionType [isEditMode]='isEditMode' [uuid]="uuid" (next)="goToActionDefinitions($event)"></well-subscription-type-tab>

      <div wellWizardTabFooter class="footer">
          <label>{{'company.utils.requiredLabel' | translate }}</label>
          <div class="pull-right">
            <button pButton [label]="'company.utils.cancel' | translate" class="p-button-text mr" type="button"
                    (click)="onCancel()" data-testid="on-cancel-btn"></button>
            <button pButton [label]="'company.utils.save' | translate" type="submit"
                    (click)="subscriptionType.onSave()" data-testid="subscription-type-on-save-btn"></button>
          </div>
      </div>

    </well-wizard-tab>


    <well-wizard-tab [label]="'company.subscription-type.new-actions' | translate ">

      <well-action-list-page [subscriptionTypeUuid]="uuid" *ngIf="index===1" (next)="goToSubscriptions()"> </well-action-list-page>

      <div wellWizardTabFooter class="footer">
        <label>{{'company.utils.requiredLabel' | translate }}</label>
        <div class="pull-right">
          <button pButton [label]="'company.utils.cancel' | translate" class="p-button-text mr" type="button"
                  (click)="onCancel()" data-testid="on-cancel-btn-2"></button>
          <button pButton [label]="'company.utils.next' | translate" type="submit"
                  (click)="goToSubscriptions()" data-testid="go-to-subscriptions-btn"></button>
        </div>
      </div>

    </well-wizard-tab>


    <well-wizard-tab [label]="'company.subscription-type.companies' | translate ">

      <well-subscriptions-tab [subscriptionTypeUuid]="uuid" *ngIf="index===2"> </well-subscriptions-tab>
      <div wellWizardTabFooter class="footer">
        <div class="pull-right">
          <button pButton [label]="'company.utils.cancel' | translate" class="p-button-text mr" type="button"
                  (click)="onCancel()" data-testid="on-cancel-btn-3"></button>
        </div>
      </div>
    </well-wizard-tab>

  </well-wizard>



